export default __webpack_public_path__ + "static/media/keySVG.9e3ebea2.svg";